export default __webpack_public_path__ + "5042f5dceaae19455ce2a5359670e9a3.png";